import { useState } from "react";
import { Link } from "react-router-dom";
import { faqItems } from "@/mocks/articles";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqItems.map((item) => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer,
      },
    })),
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-3 text-center">
            Frequently Asked Questions
          </h2>
          <p className="text-sm text-foreground-600 text-center mb-10 max-w-lg mx-auto">
            Everything you need to know about Vigorbuy Spreadsheet and how it helps you shop smarter.
          </p>

          <div className="space-y-3">
            {faqItems.map((item, index) => (
              <div
                key={index}
                className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-200"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {item.question}
                  </span>
                  <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center">
                    <i
                      className={`text-foreground-500 transition-transform duration-300 text-lg ${
                        openIndex === index ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    ></i>
                  </span>
                </button>
                <div
                  className={`transition-all duration-300 ease-in-out overflow-hidden ${
                    openIndex === index ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 text-center">
            <p className="text-sm text-foreground-500">
              Have more questions? Check out our{" "}
              <Link to="/shopping-guide" className="text-primary-600 hover:text-primary-700 font-medium">
                complete shopping guide
              </Link>
              {" "}or{" "}
              <Link to="/article/vigorbuy-spreadsheet-complete-guide" className="text-primary-600 hover:text-primary-700 font-medium">
                in-depth platform guide
              </Link>
              {" "}for detailed answers.
            </p>
          </div>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </section>
  );
}